import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import moment from "moment";
import UserServices from "../../UserServices/UserServices";
import { NoteState } from "../../context/notes/NoteState";
import { clientReport } from "../schemas";
import Swal from "sweetalert2";
import useSortableData from "../../hooks/useSortableData";
import CurrencyFormat from "react-currency-format";
import jsPDF from "jspdf";
import "jspdf-autotable";
import $ from "jquery";
import MenuButton from "../MenuButton/MenuButton";

export default function CafeSalesReport() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;
  const [loading, setLoading] = useState(false);
  const [summaryData, setSummaryData] = useState([]);
  const [summaryExport, setSummaryExport] = useState("");
  const [show, setShow] = useState(false);
  const [DAteSeted, setDAteSeted] = useState(false);

  const date = new Date();
  const defaultValue = date.toLocaleDateString("en-CA");
  const dateSelected = moment(defaultValue).format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(dateSelected);
  const [endDate, setEndDate] = useState(dateSelected);

  const normalizeDate = (dateStr) => moment(dateStr).format("YYYY-MM-DD");

  const setDates = async (param) => {
    setDAteSeted(true);
    try {
      const response = await UserServices.getStartEndDates(param);
      if (response.status === 200) {
        setStartDate(response.data.StartDate);
        setEndDate(response.data.EndDate);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDAteSeted(false);
    }
  };

  const summaryReport = async (values) => {
    if (Date.parse(values.sdate) <= Date.parse(values.edate)) {
      setLoading(true);
      try {
        setSummaryData([]);
        setSummaryExport(
          `${process.env.REACT_APP_API_Link}/export-transaction-summary?branch_id=${branch_id}&start_date=${values.sdate}&end_date=${values.edate}&category=10`
        );

        const results = await Promise.allSettled([
          UserServices.getSummerySaleReportAllNew(15, values),
          UserServices.getSummerySaleReportAllNew(1, values),
          UserServices.getExpences(15, 1000, 1, { startdate: values.sdate, enddate: values.edate }),
          UserServices.getExpences(1, 1000, 1, { startdate: values.sdate, enddate: values.edate }),
          UserServices.getCafeSummaryReport(15, values)
        ]);

        const [f11SalesRes, g13SalesRes, f11ExpenseRes, g13ExpenseRes, cafeRes] = results.map(
          (res) => (res.status === "fulfilled" ? res.value : { status: 500, data: [] })
        );

        const myDataarr = cafeRes.status === 200 ? cafeRes.data.data.map((value) => ({
          order_date: normalizeDate(value.order_date),
          cafeSales: value.total_net_price || 0,
        })) : [];

        const f11SalesData = f11SalesRes.status === 200 ? f11SalesRes.data.immediate.map((value) => {
          // Find cafe sales for this date
          const cafeSaleForDate = cafeRes.status === 200
            ? (cafeRes.data.data.find((cafe) => normalizeDate(cafe.order_date) === normalizeDate(value.date))?.total_net_price || 0)
            : 0;
          return {
            date: normalizeDate(value.date),
            // Add cafe sales to f11Sales
            f11Sales: ((value.pending || 0) + (value.Online || 0) + (value.Credit_Card || 0) + (value.Cash || 0)) + Number(cafeSaleForDate),
          };
        }) : [];

        const g13SalesData = g13SalesRes.status === 200 ? g13SalesRes.data.immediate.map((value) => ({
          date: normalizeDate(value.date),
          g13Sales: (value.pending || 0) + (value.Online || 0) + (value.Credit_Card || 0) + (value.Cash || 0),
        })) : [];

        const groupExpensesByDate = (expenses) => {
          const grouped = {};
          if (Array.isArray(expenses)) {
            expenses.forEach((item) => {
              const date = normalizeDate(item.occurrence_date);
              grouped[date] = (grouped[date] || 0) + Number(item.amount);
            });
          }
          return Object.entries(grouped).map(([date, totalAmount]) => ({ date, totalAmount }));
        };

        const f11ExpensesData = f11ExpenseRes?.data?.data?.data || [];
        const g13ExpensesData = g13ExpenseRes?.data?.data?.data || [];
        const f11ExpensesGrouped = groupExpensesByDate(f11ExpensesData).map((item) => ({
          date: item.date,
          f11Expense: item.totalAmount,
        }));
        const g13ExpensesGrouped = groupExpensesByDate(g13ExpensesData).map((item) => ({
          date: item.date,
          g13Expense: item.totalAmount,
        }));



        const combinedData = [];
        const allDates = new Set([
          ...f11SalesData.map((d) => d.date),
          ...g13SalesData.map((d) => d.date),
          ...f11ExpensesGrouped.map((d) => d.date),
          ...g13ExpensesGrouped.map((d) => d.date),
          ...myDataarr.map((d) => d.order_date),
        ]);

        allDates.forEach((date) => {
          const f11 = f11SalesData.find((d) => d.date === date)?.f11Sales || 0;
          const g13 = g13SalesData.find((d) => d.date === date)?.g13Sales || 0;
          const f11Exp = f11ExpensesGrouped.find((d) => d.date === date)?.f11Expense || 0;
          const g13Exp = g13ExpensesGrouped.find((d) => d.date === date)?.g13Expense || 0;
          const cafe = myDataarr.find((d) => d.order_date === date)?.cafeSales || 0;

          combinedData.push({
            order_date: date,
            f11Sales: f11,
            g13Sales: g13,
            f11Expense: f11Exp,
            g13Expense: g13Exp,
            cafeSales: cafe,
          });
        });

        combinedData.sort((a, b) => new Date(a.order_date) - new Date(b.order_date));

        const filteredData = combinedData.filter(
          (row) => row.f11Sales !== 0 || row.g13Sales !== 0 || row.cafeSales !== 0 || row.f11Expense !== 0 || row.g13Expense !== 0
        );

        setSummaryData(filteredData);
        setShow(true);
      } catch (err) {
        console.error("Error in summaryReport:", err);
        setSummaryExport("");
        if (err.response?.status === 401) {
          setSummaryData([]);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Request time Out! Please login again.",
            confirmButtonColor: "#e72e2e",
            confirmButtonText: "Log In Again!",
          });
        } else {
          setSummaryData([]);
        }
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "End date should be greater than start date!",
      });
    }
  };

  const generatePdf = () => {
    const doc = new jsPDF("p", "mm", "letter");
    const tables = document.querySelectorAll("table");
    const tableOptions = {
      headStyles: { fillColor: [232, 0, 43], textColor: 255 },
      styles: { fontSize: 5 },
    };
    let currentY = 10;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    tables.forEach((table) => {
      const captionText = table.getAttribute("data-caption");
      const tableHeight = doc.autoTable.previous?.finalY - currentY || 0;
      if (currentY + tableHeight + 20 > pageHeight) {
        doc.addPage();
        currentY = 10;
      }

      doc.text(captionText, 10, currentY);
      currentY += 5;

      doc.autoTable({
        html: table,
        startY: currentY,
        ...tableOptions,
      });

      const tableBottomY = doc.autoTable.previous.finalY + 5;
      const lineWidth = pageWidth - 20;
      doc.setDrawColor(0);
      doc.line(10, tableBottomY, 10 + lineWidth, tableBottomY);
      currentY = tableBottomY + 10;
    });

    doc.save("Sales_And_Expense_Report.pdf");
  };

  const SummaryTable = ({ data }) => {
    const { items, requestSort, sortConfig } = useSortableData(data);
    const getClassNamesFor = (name) => sortConfig?.key === name ? sortConfig.direction : undefined;

    const toNumber = (value) => Number(String(value).replace(/[^0-9.-]+/g, "")) || 0;

    const totals = data.reduce(
      (acc, row) => ({
        f11Sales: acc.f11Sales + toNumber(row.f11Sales),
        g13Sales: acc.g13Sales + toNumber(row.g13Sales),
        cafeSales: acc.cafeSales + toNumber(row.cafeSales),
        f11Expense: acc.f11Expense + toNumber(row.f11Expense),
        g13Expense: acc.g13Expense + toNumber(row.g13Expense),
      }),
      { f11Sales: 0, g13Sales: 0, cafeSales: 0, f11Expense: 0, g13Expense: 0 }
    );

    const gst = {
      f11Sales: totals.f11Sales * 0.05,
      g13Sales: totals.g13Sales * 0.05,
      cafeSales: totals.cafeSales * 0.05,
    };

    const afterGst = {
      f11Sales: totals.f11Sales - gst.f11Sales,
      g13Sales: totals.g13Sales - gst.g13Sales,
      cafeSales: totals.cafeSales - gst.cafeSales,
    };

    return (
      <>
        <div className="col-md-12 mt-2">
          <div className="row">
            <div className="col-md-6">
              <h5 className="mb-0 text-uppercase">Filtered Result</h5>
            </div>
            <div className="col-md-3" />
            <div className="col-md-3 text-end">
              <button
                className="btn btn-primary mx-2 file-download float-end mb-3"
                onClick={() => generatePdf()}
              >
                <i className="bi bi-file-earmark-pdf"></i> PDF
              </button>
            </div>
          </div>
          <hr />
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-borderless table-style-1" data-caption={`Daily Sales and Expense Report (${moment(values.sdate).format("DD-MM-YYYY")} - ${moment(values.edate).format("DD-MM-YYYY")})`}>                <thead>
                <tr>
                  <th scope="col" className="no_sort">Sr#</th>
                  <th scope="col" onClick={() => requestSort("order_date")} className={getClassNamesFor("order_date")}>
                    Date
                  </th>
                  <th scope="col">F-11 Sales</th>
                  <th scope="col">G-13 Sales</th>
                  {/* <th scope="col">Cafe Sales</th> */}
                  <th scope="col">F-11 Expense</th>
                  <th scope="col">G-13 Expense</th>
                </tr>
              </thead>
                <tbody>
                  {items.length ? items.map((el, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{moment(el.order_date).format("DD-MM-YYYY")}</td>
                      <td><CurrencyFormat value={toNumber(el.f11Sales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      <td><CurrencyFormat value={toNumber(el.g13Sales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      {/* <td><CurrencyFormat value={toNumber(el.cafeSales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td> */}
                      <td><CurrencyFormat value={toNumber(el.f11Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      <td><CurrencyFormat value={toNumber(el.g13Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="8" className="text-center text-capitalize">No record found</td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  <tr style={{ backgroundColor: "#FFFF00", fontWeight: "bold" }}>
                    <td colSpan="2">Total</td>
                    <td><CurrencyFormat value={toNumber(totals.f11Sales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    <td><CurrencyFormat value={toNumber(totals.g13Sales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    {/* <td><CurrencyFormat value={toNumber(totals.cafeSales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td> */}
                    <td><CurrencyFormat value={toNumber(totals.f11Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    <td><CurrencyFormat value={toNumber(totals.g13Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                  </tr>
                  <tr style={{ backgroundColor: "#FFFFCC", fontWeight: "bold" }}>
                    <td colSpan="2">Less: GST 5%</td>
                    <td><CurrencyFormat value={toNumber(gst.f11Sales.toFixed(2))} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    <td><CurrencyFormat value={toNumber(gst.g13Sales.toFixed(2))} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    {/* <td><CurrencyFormat value={toNumber(gst.cafeSales.toFixed(2))} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td> */}
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr style={{ backgroundColor: "#00BFFF", color: "white", fontWeight: "bold" }}>
                    <td colSpan="2">Sale After GST</td>
                    <td><CurrencyFormat value={toNumber(afterGst.f11Sales.toFixed(2))} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    <td><CurrencyFormat value={toNumber(afterGst.g13Sales.toFixed(2))} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                    {/* <td><CurrencyFormat value={toNumber(afterGst.cafeSales.toFixed(2))} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td> */}
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-borderless table-style-1" data-caption={`F-11 Summary Report (${moment(values.sdate).format("DD-MM-YYYY")} - ${moment(values.edate).format("DD-MM-YYYY")})`}>                    <thead>
                    <tr>
                      <th scope="col">F-11 </th>
                      <th scope="col">Amount</th>
                    </tr>
                  </thead>
                    <tbody>
                      <tr>
                        <td>Gym Sale</td>
                        <td><CurrencyFormat value={toNumber(totals.f11Sales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr>
                      {/* <tr>
                        <td>Cafe Sale</td>
                        <td><CurrencyFormat value={toNumber(totals.cafeSales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr> */}
                      {/* <tr>
                        <td>Total Sales</td>
                        <td><CurrencyFormat value={toNumber(totals.f11Sales + totals.cafeSales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr> */}
                      <tr>
                        <td>Less: Expense</td>
                        <td><CurrencyFormat value={toNumber(totals.f11Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr>
                      <tr style={{ backgroundColor: "#FFFFCC", fontWeight: "bold" }}>
                        <td>Difference</td>
                        <td><CurrencyFormat value={toNumber(totals.f11Sales - totals.f11Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-borderless table-style-1" data-caption={`G-13 Summary Report (${moment(values.sdate).format("DD-MM-YYYY")} - ${moment(values.edate).format("DD-MM-YYYY")})`}>
                    <thead>
                      <tr>
                        <th scope="col">G-13</th>
                        <th scope="col">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Gym Sale</td>
                        <td><CurrencyFormat value={toNumber(totals.g13Sales)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr>
                      <tr>
                        <td>Less: Expense</td>
                        <td><CurrencyFormat value={toNumber(totals.g13Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr>
                      <tr style={{ backgroundColor: "#FFFFCC", fontWeight: "bold" }}>
                        <td>Difference</td>
                        <td><CurrencyFormat value={toNumber(totals.g13Sales - totals.g13Expense)} displayType="text" thousandSeparator prefix="Rs " suffix="/-" /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    enableReinitialize: true,
    initialValues: { sdate: startDate, edate: endDate, searchVal: "" },
    validationSchema: clientReport,
    onSubmit: summaryReport,
  });

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-20">Daily Sales And Expense Analysis</h5>
            </div>
            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="link-hirarcy">
                  <span className="text-danger">Reports</span> » Sales And Expense
                </div>
                <div className="col-12">
                  <h5>Dates</h5>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">Start date</label>
                    <input
                      type="date"
                      className={`form-control ${DAteSeted ? "glow" : ""}`}
                      placeholder="Enter Start date"
                      name="sdate"
                      value={values.sdate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.sdate && touched.sdate && <p className="text-danger">{errors.sdate}</p>}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group custom-group">
                    <label className="form-label">End date</label>
                    <input
                      type="date"
                      className={`form-control ${DAteSeted ? "glow" : ""}`}
                      placeholder="Enter End date"
                      name="edate"
                      value={values.edate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.edate && touched.edate && <p className="text-danger">{errors.edate}</p>}
                  </div>
                </div>
                <div className="col-12 col-md-4 col-lg-2 offset-md-4 offset-lg-5">
                  <button
                    disabled={DAteSeted}
                    type="submit"
                    className="btn btn-primary px-5 rounded-0 w-100"
                  >
                    Go
                  </button>
                </div>
              </form>
            </div>
          </div>
          {show && <SummaryTable data={summaryData} />}
        </div>
      </main>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
